(function () {
  var container = document.querySelector('[data-locally-config]');
  if (!container) return;

  var companyDomain = container.getAttribute('data-company-domain');
  var companyName = container.getAttribute('data-company-name');
  var companyId = container.getAttribute('data-company-id');
  var upc = container.getAttribute('data-upc');
  var lang = container.getAttribute('data-lang');
  var buttonText = container.getAttribute('data-button-text');
  var numDealers = container.getAttribute('data-num-dealers') || '2';

  if (!companyDomain || !companyId || !upc) return;

  var base = 'https://' + companyDomain + '.locally.com';

  var queryParts = [
    "company_name=" + encodeURIComponent(companyName),
    "show_dealers=" + encodeURIComponent(numDealers),
    "n_dealers=" + encodeURIComponent(numDealers),
    "button_text=" + encodeURIComponent(buttonText || 'Find more retailers'),
    "button_id=HTML",
    "company_id=" + encodeURIComponent(companyId),
    "upc=" + encodeURIComponent(upc),
    "css=6",
    "show_location_switcher=0",
    "show_location_prompt=1",
    "lang=" + encodeURIComponent(lang || 'en-us'),
    "show_directions=1",
    "no_link=1"
  ];

  var queryString = "'" + queryParts.join("&");

  document.getElementById('lcly-script-0').src = base + '/stores/map.js?' + queryString;
  document.getElementById('lcly-script-switchlive-0').src = base + '/js/switchlive.js?company_id=' + companyId;
  document.getElementById('lcly-script-switchlive-events-0').src = base + '/switchlive/switchlive-events.js?company_id=' + companyId;
})();
